import type { AccountDataSelection } from '@labrav/common'
import { multiCurrencyOptions } from '@labrav/common'
import AwsLogo from '../../common/images/awsCloudNew.svg'
import AzureLogo from '../../common/images/azureCloudNew.svg'
import GcpLogo from '../../common/images/gcpCloudNew.svg'

export const getCloudLogoSrc = (cloud?: string) => {
  if (cloud === 'AWS') {
    return AwsLogo
  }
  if (cloud === 'AZURE') {
    return AzureLogo
  }
  if (cloud === 'GCP') {
    return GcpLogo
  }
  return ''
}

export const formatAccountCurrencies = (currencies?: string[]) =>
  currencies
    ?.map(
      item =>
        `${item} (${multiCurrencyOptions.find(option => option.code === item)?.symbol})`
    )
    .join(', ') || '-'

export const isFlyoutAccount = (account: AccountDataSelection) =>
  account.product?.toLowerCase() === 'flyout'
